<template>
  <v-container class="pa-0">
    <v-row justify="center" align="center">
      <v-col v-if="clientInformation">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="secondary"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.calendar = true"
            >
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>
          <span>Block history</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="secondary"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.notes = true"
            >
              <v-icon>mdi-notebook</v-icon>
            </v-btn>
          </template>
          <span>Notes</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="exercise"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.trainingLog = true"
            >
              <v-icon>fitness_center</v-icon>
              <div v-if="actions.activityLoggedToday" class="exercise-dot"></div>
            </v-btn>
          </template>
          <span>{{ actions.activityLoggedToday || "Activity Log" }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="nutrition"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.nutritionLog = true"
            >
              <v-icon>local_dining</v-icon>
            </v-btn>
          </template>
          <span>Nutrition Log</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              class="mx-2 accent my-2 lighten-5"
              color="selection"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.reflectionLog = true"
            >
              <v-icon>stars</v-icon>
            </v-btn>
          </template>
          <span>Reflection Log</span>
        </v-tooltip>
        <v-tooltip v-if="clientInformation.hubspotContactVid" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="facebook-blue"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="goToDeals(clientInformation.user.email)"
            >
              <v-icon>mdi-account-supervisor-circle</v-icon>
            </v-btn>
          </template>
          <span>Deals</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="whatsapp-green"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              target="_blank"
              :href="'/clients/' + userId"
            >
              <v-icon>account_circle</v-icon>
            </v-btn>
          </template>
          <span>Full profile</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="secondary"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.tasks = true"
            >
              <v-icon>mdi-clipboard-list-outline</v-icon>
            </v-btn>
          </template>
          <span>Task history</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="pink"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.engagement = true"
            >
              <v-icon>mdi-graphql</v-icon>
            </v-btn>
          </template>
          <span>Engagement</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="pink"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="showCreateDealDialog"
            >
              <v-icon>mdi-hubspot</v-icon>
            </v-btn>
          </template>
          <span>Hubspot deals</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="facebook-blue"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.subscriptions = true"
            >
              <v-icon>mdi-account-cash</v-icon>
            </v-btn>
          </template>
          <span>Subscription history</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="facebook-blue"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.userPosts = true"
            >
              <v-icon>comment</v-icon>
            </v-btn>
          </template>
          <span>Group posts</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="yellow darken-1"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.checkIns = true"
            >
              <v-icon>mdi-calendar-check</v-icon>
            </v-btn>
          </template>
          <span>Check-ins</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              elevation="13"
              color="whatsapp-green darken-1"
              class="mx-2 accent my-2 lighten-5"
              dark
              v-bind="attrs"
              v-on="on"
              @click="modals.blockRecommendation = true"
            >
              <v-icon>mdi-run</v-icon>
            </v-btn>
          </template>
          <span>Block Recommendation</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-dialog v-model="modals.notes" class="limited-height" width="900" transition="dialog-bottom-transition">
      <user-notes
        v-if="modals.notes"
        :userId="userId"
        :userName="username"
        :coachId="currentUser"
        @problem="emitProblem()"
        @close="closeNotes"
      />
    </v-dialog>

    <v-dialog v-model="modals.calendar" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="blue">
          <v-toolbar-title>User blocks</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.calendar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <calendar v-if="modals.calendar" :userId="userId"></calendar>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.trainingLog" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="exercise">
          <v-toolbar-title>Activity Log for {{ clientName() }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.trainingLog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <weekly-training-log :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.nutritionLog" persistent width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Nutrition Log for {{ clientName() }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.nutritionLog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <weekly-nutrition-log :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.reflectionLog" persistent width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Reflection Log</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.reflectionLog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <reflection :userId="userId"></reflection>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.tasks" persistent width="1300" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Task history</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.tasks = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <task-history :userId="userId"></task-history>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.engagement" persistent width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Engagement</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.engagement = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <user-engagement :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.deals" persistent width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Hubspot deals</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.deals = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <client-deals :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.subscriptions" persistent width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Subscription history</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.subscriptions = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <client-subscription :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.userPosts" persistent width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Group posts</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.userPosts = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <user-posts :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="modals.checkIns"
      persistent
      max-width="1100"
      transition="dialog-bottom-transition"
      class="full-height overflow-hidden"
    >
      <v-card class="full-height overflow-hidden">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Check-ins</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.checkIns = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <assessments :userId="userId" :showBackLink="false" />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="modals.blockRecommendation"
      persistent
      max-width="1100"
      transition="dialog-bottom-transition"
      class="full-height overflow-hidden"
    >
      <v-card class="full-height overflow-hidden">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Recommended block</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="modals.blockRecommendation = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <recommended-journey :userId="userId" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="createDealDialog" persistent width="800">
      <v-toolbar>
        Create Deal
        <v-spacer />
        <v-btn icon dark @click="createDealDialog = false" color="primary">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-sheet v-if="stages">
        <deal-create-new
          ref="dealCreateForm"
          :deal-owners="dealOwners"
          :stages="stages"
          :types="types"
          @result="createDealResult"
        />
      </v-sheet>
    </v-dialog>
  </v-container>
</template>

<script>
import { CLIENT_INFORMATION_SHORT_QUERY } from "@/graphql/queries/user";
import WeeklyTrainingLog from "../../training_log/WeeklyTrainingLog";
import WeeklyNutritionLog from "../../nutrition/WeeklyNutritionLog";
import Reflection from "@/components/client/blocks/reflection/Reflection";
import Calendar from "@/components/dashboard/components/Calendar";
import UserNotes from "@/components/dashboard/components/notes/UserNotes";
import TaskHistory from "@/components/task/components/TaskHistory";
import UserEngagement from "@/components/reporting/blocks/UserEngagement";
import ClientDeals from "@/components/client/blocks/ClientDeals";
import ClientSubscription from "@/components/client/blocks/ClientSubscription";
import UserPosts from "@/components/social/UserPosts";
import Assessments from "@/components/client/blocks/progress/assessments/Assessments";
import RecommendedJourney from "@/components/workout_blocks/RecommendedJourney";
import DealCreateNew from "@/components/deals/components/DealCreateNew";
import { DEAL_CONFIGURATION_QUERY, DEAL_OWNERS_QUERY } from "@/graphql/queries/deal";
import { capitalize } from "@/lib/string";

export default {
  name: "ClientActionBar",
  components: {
    UserNotes,
    WeeklyTrainingLog,
    WeeklyNutritionLog,
    Reflection,
    Calendar,
    TaskHistory,
    UserEngagement,
    ClientDeals,
    ClientSubscription,
    UserPosts,
    Assessments,
    RecommendedJourney,
    DealCreateNew,
  },
  props: ["userId"],
  data() {
    return {
      loading: true,
      actions: {
        activityLoggedToday: null,
      },
      actionClass: "",
      clientInformation: null,
      modals: {
        calendar: null,
        notes: null,
        trainingLog: null,
        nutritionLog: null,
        reflectionLog: null,
        tasks: null,
        engagement: null,
        deals: null,
        subscriptions: null,
        userPosts: null,
        checkIns: null,
        blockRecommendation: null,
      },
      createDealDialog: false,
    };
  },
  computed: {
    types() {
      return this.dealConfiguration?.types ?? null;
    },
    stages() {
      return this.dealConfiguration?.stages ?? null;
    },
    username() {
      return this.clientInformation?.user.username;
    },
    currentUser() {
      return JSON.parse(localStorage.getItem("user")) || store.getters.user;
    },
  },
  methods: {
    async createDealResult(message) {
      this.createDealDialog = false;
      this.$toasted.success(message);
    },
    async showCreateDealDialog() {
      this.createDealDialog = true;
      await this.$nextTick();
      this.$refs.dealCreateForm.init();
    },
    goToDeals(email) {
      const query = {
        dealOwner_User_Id_Isnull: false,
        search: email,
      };

      this.$router.push(`/deals?q=${JSON.stringify(query)}`);
    },
    clientName() {
      return `${this.clientInformation?.user.firstName} ${this.clientInformation?.user.lastName}`;
    },
    emitProblem() {
      this.$emit("problem");
      this.problemConnecting = true;
    },
    closeNotes() {
      this.modals.notes = false;
    },
    closeTrainingLog() {
      this.modals.trainingLog = false;
    },
    closeNutritionLog() {
      this.modals.nutritionLog = false;
    },
    closeCalendar() {
      this.modals.calendar = false;
    },
  },
  apollo: {
    dealConfiguration: {
      query: DEAL_CONFIGURATION_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.dealConfiguration;
      },
    },
    dealOwners: {
      query: DEAL_OWNERS_QUERY,
      fetchPolicy: "cache-and-network",
    },
    clientInformation: {
      query: CLIENT_INFORMATION_SHORT_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>

<style lang="scss" scoped>
.full-width {
  width: 100%;
}

.full-height {
  height: 100%;
}

.exercise-dot {
  position: absolute;
  top: 16px;
  background-color: var(--v-exercise-base);
  border: 1px solid white;
  border-radius: 100%;
  width: 22px;
  height: 22px;
}

.full-width .v-chip {
  background-color: black;
  margin-right: 5px;
}
</style>
